import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { acceptInvitation } from '../../Utils/functions';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { CircularProgress, Box, Typography, Alert, Button } from '@mui/material';

const InvitationAcceptance = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (!token) {
      setError('Invitation token not found.');
      setLoading(false);
      return;
    }

    const handleAcceptance = async () => {
      if (authStatus === 'configuring') {
        // Wait for auth to be configured
        return;
      }

      if (authStatus !== 'authenticated') {
        // Redirect to login with a redirect back to this page
        navigate(`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`);
        return;
      }

      try {
        setMessage('Accepting invitation...');
        const response = await acceptInvitation(token);
        setMessage(response.message || 'Invitation accepted successfully!');
        localStorage.setItem('organizationId', response.organizationId);
        localStorage.setItem('organizationName', response.organizationName);
        setTimeout(() => {
          navigate('/organization-dataset'); // Redirect to organization dataset page
        }, 2000);
      } catch (err) {
        setError(err.message || 'Failed to accept invitation.');
      } finally {
        setLoading(false);
      }
    };

    handleAcceptance();
  }, [location, navigate, authStatus]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>{message || 'Loading...'}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      {error && <Alert severity="error">{error}</Alert>}
      {!error && message && <Alert severity="success">{message}</Alert>}
      <Button variant="contained" onClick={() => navigate('/')} sx={{ mt: 2 }}>Go to Home</Button>
    </Box>
  );
};

export default InvitationAcceptance;